// External user roles
export enum Role {
  HOMEBUYER = 'consumer',
  AGENT = 'kca-agent',
  LENDER = 'lender',
  MORTGAGE_BROKER = 'mortgage-broker',
  KNOCKSTAR = 'employee',
}

// Internal employee roles
export enum InternalRole {
  CCR = 'ccr',
  MORTGAGE_PAYMENTS = 'mortgage-payments',
  MORTGAGE_PAYMENTS_ADMIN = 'mortgage-payments-admin',
  ENGINEERING = 'engineering',
  ENGINEERING_ADMIN = 'engineering-admin',
  PRODUCT = 'product',
  PRODUCT_ADMIN = 'product-admin',
}

// Treat Auth0 role "mortgage-broker" as equivalent to lender within apps
// @ToDo: Refactor this once we have a better sense of what the mortgage broker experience will look like
export const LENDER_EQUIVALENT_ROLES: Role[] = [Role.LENDER, Role.MORTGAGE_BROKER]
const LENDER_EQUIVALENT_ROLE_SET = new Set<string>(LENDER_EQUIVALENT_ROLES)

export const hasLenderEquivalentRole = (roles: string[] = []) =>
  roles?.some((role) => LENDER_EQUIVALENT_ROLE_SET.has(role))

export const getMainRoles = (roles: string[]) => {
  if (hasLenderEquivalentRole(roles)) {
    return Role.LENDER
  } else if (roles.includes(Role.AGENT)) {
    return Role.AGENT
  } else {
    return Role.HOMEBUYER
  }
}
